import { 
  signInAnonymously, 
  signOut, 
  onAuthStateChanged,
  updateProfile 
} from 'firebase/auth';
import { auth } from '../firebase/config';

export class AuthService {
  /**
   * Sign in anonymously (for development)
   * In production, you'd use proper authentication
   */
  static async signInAnonymously() {
    try {
      const userCredential = await signInAnonymously(auth);
      console.log('Signed in anonymously:', userCredential.user.uid);
      return userCredential.user;
    } catch (error) {
      console.error('Error signing in anonymously:', error);
      throw error;
    }
  }

  /**
   * Sign out
   */
  static async signOut() {
    try {
      await signOut(auth);
      console.log('Signed out');
    } catch (error) {
      console.error('Error signing out:', error);
      throw error;
    }
  }

  /**
   * Listen to auth state changes
   */
  static onAuthStateChanged(callback) {
    return onAuthStateChanged(auth, callback);
  }

  /**
   * Get current user
   */
  static getCurrentUser() {
    return auth.currentUser;
  }

  /**
   * Update user profile with wallet address
   */
  static async updateUserProfile(walletAddress) {
    try {
      const user = auth.currentUser;
      if (user) {
        await updateProfile(user, {
          displayName: `Wallet: ${walletAddress.slice(0, 6)}...${walletAddress.slice(-4)}`
        });
        console.log('Updated user profile with wallet address');
      }
    } catch (error) {
      console.error('Error updating user profile:', error);
      throw error;
    }
  }

  /**
   * Check if user is authenticated
   */
  static isAuthenticated() {
    return !!auth.currentUser;
  }
}
